var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7127 10.9367C76.5358 9.75781 74.6263 9.75578 73.4494 10.9317L37.2786 47.007L24.2283 32.8331C23.1006 31.6091 21.1941 31.5297 19.968 32.6572C18.7428 33.7848 18.6644 35.6923 19.792 36.9175L34.968 53.3989C35.5238 54.003 36.3016 54.3537 37.1217 54.3708C37.1438 54.3717 37.165 54.3717 37.1861 54.3717C37.9831 54.3717 38.7498 54.0552 39.3147 53.4923L77.7067 15.2009C78.8866 14.0252 78.8886 12.1156 77.7127 10.9367Z",
    fill: "#193867"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9848 36.9848C75.3195 36.9848 73.9698 38.3345 73.9698 40C73.9698 58.7317 58.7317 73.9698 40 73.9698C21.2694 73.9698 6.03016 58.7317 6.03016 40C6.03016 21.2694 21.2694 6.03016 40 6.03016C41.6653 6.03016 43.0152 4.68047 43.0152 3.01516C43.0152 1.34969 41.6653 0 40 0C17.9437 0 0 17.9437 0 40C0 62.0553 17.9437 80 40 80C62.0553 80 80 62.0553 80 40C80 38.3347 78.6503 36.9848 76.9848 36.9848Z",
    fill: "#193867"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.e35ceb2c.svg";
export { ForwardRef as ReactComponent };